export default __webpack_public_path__ + "static/media/descripcionCargaCedula.332dd79e.svg";